export default [
  {
    "VARIABLE": "1.1.1. Calidad del aire interior",
    "REQUERIMIENTO": "1.1.1.a  Ventilación mínima",
    "NORTE": "✓",
    "CENTRO": "✓",
    "SUR": "✓"
  },
  {
    "VARIABLE": "1.1.1. Calidad del aire interior",
    "REQUERIMIENTO": "1.1.1.d  Contaminación aérea intradomiciliaria",
    "NORTE": "",
    "CENTRO": "",
    "SUR": "✓"
  },
  {
    "VARIABLE": "1.1.2. Confort higrotérmico",
    "REQUERIMIENTO": "1.1.2.a  Confort térmico pasivo",
    "NORTE": "✓",
    "CENTRO": "✓",
    "SUR": "✓"
  },
  {
    "VARIABLE": "1.1.2. Confort higrotérmico",
    "REQUERIMIENTO": "1.1.2.b  Riesgo de condensación",
    "NORTE": "",
    "CENTRO": "✓",
    "SUR": "✓"
  },
  {
    "VARIABLE": "1.1.4. Confort lumínico y visual",
    "REQUERIMIENTO": "1.1.4.b  Vista al exterior",
    "NORTE": "✓",
    "CENTRO": "✓",
    "SUR": "✓"
  },
  {
    "VARIABLE": "1.2.1. Solución para el secado de ropa",
    "REQUERIMIENTO": "1.2.1.a  Solución al secado de ropa",
    "NORTE": "",
    "CENTRO": "✓",
    "SUR": "✓"
  },
  {
    "VARIABLE": "1.3.1. Manual de usuario de la vivienda",
    "REQUERIMIENTO": "1.3.1.a  Manual de usuario de la vivienda",
    "NORTE": "✓",
    "CENTRO": "✓",
    "SUR": "✓"
  },
  {
    "VARIABLE": "2.1.1. Reducción de demanda térmica en viviendas",
    "REQUERIMIENTO": "2.1.1.a  Reducción de demanda térmica mínima",
    "NORTE": "✓",
    "CENTRO": "✓",
    "SUR": "✓"
  },
  {
    "VARIABLE": "2.2.2. Infiltraciones",
    "REQUERIMIENTO": "2.2.2.a  Sellos en uniones y encuentros",
    "NORTE": "✓",
    "CENTRO": "✓",
    "SUR": "✓"
  },
  {
    "VARIABLE": "2.3.1. Sistemas de calefacción energéticamente eficientes",
    "REQUERIMIENTO": "2.3.1.b  Calefacción de viviendas",
    "NORTE": "",
    "CENTRO": "",
    "SUR": "✓"
  },
  {
    "VARIABLE": "3.2.1. Consumo interno de agua",
    "REQUERIMIENTO": "3.2.1.a  Artefactos sanitarios eficientes",
    "NORTE": "✓",
    "CENTRO": "✓",
    "SUR": "✓"
  },
  {
    "VARIABLE": "3.2.2. Consumo externo de agua",
    "REQUERIMIENTO": "3.2.2.a  Paisajismo de bajo requerimiento hídrico",
    "NORTE": "✓",
    "CENTRO": "✓",
    "SUR": ""
  },
  {
    "VARIABLE": "3.2.2. Consumo externo de agua",
    "REQUERIMIENTO": "3.2.2.b  Riego eficiente",
    "NORTE": "✓",
    "CENTRO": "✓",
    "SUR": ""
  },
  {
    "VARIABLE": "4.3.1. Infraestructura para gestión de residuos domiciliarios",
    "REQUERIMIENTO": "4.3.1.a  Infraestructura para gestión de residuos domiciliarios",
    "NORTE": "✓",
    "CENTRO": "✓",
    "SUR": "✓"
  },
  {
    "VARIABLE": "4.4.1. Gestión y monitoreo de residuos de construcción y demolición",
    "REQUERIMIENTO": "4.4.1.a  Gestión y monitoreo de residuos de construcción y demolición",
    "NORTE": "✓",
    "CENTRO": "✓",
    "SUR": "✓"
  },
  {
    "VARIABLE": "5.4.1. Proceso de diseño integrado",
    "REQUERIMIENTO": "5.4.1.a  Condiciones para un proceso de diseño integrado",
    "NORTE": "✓",
    "CENTRO": "✓",
    "SUR": "✓"
  },
  {
    "VARIABLE": "6.1.1. Acceso a transporte público",
    "REQUERIMIENTO": "6.1.1.a  Acceso a transporte público",
    "NORTE": "✓",
    "CENTRO": "✓",
    "SUR": "✓"
  },
  {
    "VARIABLE": "6.1.3. Cercanía a equipamiento y servicios básicos",
    "REQUERIMIENTO": "6.1.3.a Cercanía a equipamiento y servicios básicos",
    "NORTE": "✓",
    "CENTRO": "✓",
    "SUR": "✓"
  },
  {
    "VARIABLE": "Recuento",
    "REQUERIMIENTO": "",
    "NORTE": 14,
    "CENTRO": 16,
    "SUR": 16
  }
]